import React,{useState,useEffect} from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import { db } from '../firebase.config';
import { collection, deleteDoc, doc, getDocs } from 'firebase/firestore';
import Faqlist from '../Components/Faqs/Faqlist';
const Faq = () => {
    const [faq, setFaq] = useState([])
    const fetchProperties = async () =>{
        const querySnapshot = await getDocs(collection(db, "faqs"));
        querySnapshot.forEach((doc) => {
         setFaq((prev)=>[...prev,{
          id:doc.id,
          ...doc.data()
         }])
       
      
        });
      }
      useEffect(() => {
        fetchProperties()
       }, [])
  return (
    <div>
        <MultiLevelSidebar />
        <Faqlist faqs={faq} />
    </div>
  )
}

export default Faq